/** Shared popover / card styling for Help menu and guided tour steps. */
export const GUIDED_TOUR_POPOVER_PAPER_SX = {
  borderRadius: 3,
  p: 2,
  minWidth: 260,
  maxWidth: 320,
  boxShadow: "0 12px 40px rgba(15, 23, 42, 0.12)",
  bgcolor: "background.paper",
  position: "relative",
};

export const GUIDED_TOUR_POPOVER_CONTENT_SPACING = 1.5;

export const GUIDED_TOUR_ACTION_BUTTON_SX = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: 2,
};

export const GUIDED_TOUR_CLOSE_BUTTON_SX = {
  position: "absolute",
  right: 8,
  top: 8,
  color: (theme) => theme.palette.grey[500],
};

export const GUIDED_TOUR_CENTER_DIALOG_PAPER_SX = {
  ...GUIDED_TOUR_POPOVER_PAPER_SX,
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  m: 0,
  width: "calc(100% - 32px)",
};
